module.exports = __webpack_public_path__ + "img/r-140.03834559.jpg";